export const formatPts = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return '0';
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: Number.isInteger(num) ? 0 : 2,
  }).format(num);
};

export const formatPtsLabel = (value) => `${formatPts(value)} PTS`;

export const toIntPercent = (current, target) => {
  const c = Number(current);
  const t = Number(target);
  if (!Number.isFinite(c) || !Number.isFinite(t) || t <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((c / t) * 100)));
};

export const unwrapData = (response) => {
  if (!response) return null;
  if (response.success === false) return null;
  const data = response.data ?? response.result ?? response;
  if (data?.result && typeof data.result === 'object') return data.result;
  return data;
};

export const unwrapList = (response) => {
  const data = unwrapData(response);
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data?.rewards)) return data.rewards;
  if (Array.isArray(data?.history)) return data.history;
  if (Array.isArray(data?.milestones)) return data.milestones;
  return [];
};

export const pick = (obj, ...keys) => {
  for (const key of keys) {
    const value = obj?.[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return null;
};
